<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('country')"
      prop="country"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.country"
        @input="form.country = valueTrimLeft($event)"
        @change="updateModelItem('country', { required: true })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('vat-value')"
      prop="vatValue"
      :rules="getValidationRule('required,number')"
      class="material-style">
      <el-input
        ref="secondField"
        :value="form.vatValue"
        @input="form.vatValue = valueNumber($event)"
        @change="updateModelItem('vatValue', { required: true })"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormVats',
  mixins: [Form]
}
</script>
